import { get as r } from "react-hook-form";
var t = function t(_t, n, e) {
    if (_t && "reportValidity" in _t) {
      var i = r(e, n);
      _t.setCustomValidity(i && i.message || ""), _t.reportValidity();
    }
  },
  n = function n(r, _n) {
    var e = function e(_e) {
      var i = _n.fields[_e];
      i && i.ref && "reportValidity" in i.ref ? t(i.ref, _e, r) : i.refs && i.refs.forEach(function (n) {
        return t(n, _e, r);
      });
    };
    for (var i in _n.fields) {
      e(i);
    }
  },
  e = function e(r) {
    return r instanceof Date;
  },
  i = function i(r) {
    return null == r;
  },
  a = function a(r) {
    return "object" == typeof r;
  },
  o = function o(r) {
    return !i(r) && !Array.isArray(r) && a(r) && !e(r);
  },
  f = function f(r) {
    return /^\w*$/.test(r);
  },
  s = function s(r, t, n) {
    for (var e = -1, i = f(t) ? [t] : function (r) {
        return t = r.replace(/["|']|\]/g, "").split(/\.|\[/), Array.isArray(t) ? t.filter(Boolean) : [];
        var t;
      }(t), a = i.length, s = a - 1; ++e < a;) {
      var u = i[e],
        c = n;
      if (e !== s) {
        var l = r[u];
        c = o(l) || Array.isArray(l) ? l : isNaN(+i[e + 1]) ? {} : [];
      }
      r[u] = c, r = r[u];
    }
    return r;
  },
  u = function u(t, e) {
    e.shouldUseNativeValidation && n(t, e);
    var i = {};
    for (var a in t) {
      var o = r(e.fields, a),
        f = Object.assign(t[a] || {}, {
          ref: o && o.ref
        });
      if (c(e.names || Object.keys(t), a)) {
        var u = Object.assign({}, r(i, a));
        s(u, "root", f), s(i, a, u);
      } else s(i, a, f);
    }
    return i;
  },
  c = function c(r, t) {
    return r.some(function (r) {
      return r.startsWith(t + ".");
    });
  };
export { e as isDateObject, f as isKey, i as isNullOrUndefined, o as isObject, a as isObjectType, u as toNestErrors, n as validateFieldsNatively };